export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/currentCode/query`,
          data
        });
      },
      remove(data) {
          return http.json({
              url: `/currentCode/delete?id=${data[0].id}`,
              data
          })
      },


  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/visitors.js